import {getNodeInternalUrl} from "../../constants/appRoutes";
import {REQUEST_ERROR} from "../request/requestActions";
import {CATALOG_FETCH} from "../../state/catalog/catalogActions";
import {setRedirectUrl} from "../../state/miscellaneous/miscellaneousActions";
import {NODE_FETCH} from "../../state/node/nodeActions";

const nodeMiddleware =
  ({dispatch}) =>
  next =>
  action => {
    const res = next(action);

    if (
      action.type === REQUEST_ERROR &&
      (action.payload.statusCode !== 403 || !action.payload?.response?.Reason) &&
      (action.payload.label === NODE_FETCH || action.payload.label === CATALOG_FETCH)
    ) {
      dispatch(setRedirectUrl(getNodeInternalUrl(action.payload.extra.nodeCode.toLowerCase())));
    }

    return res;
  };

export default nodeMiddleware;
